export default {
  disableNew: true,
  deleteTitle: 'Log Event',
  overviewTitle: 'Log Events',
  overviewRouterUrl: 'events',
  getFilterName (context) { return 'events' },
  overviewApiUrl: '/logging/',
  detailTitle: 'Log Event Detail',
  detailRouterUrl: 'event',
  detailApiUrl: '/logging/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  advancedSearch: true,
  sortOrder: [
    {
      field: 'le_time',
      sortField: 'le_time',
      direction: 'desc'
    }
  ],
  fields:
  [
    {title: 'Time', name: 'le_time', sortField: 'le_time', callback: 'formatTimeStamp'},
    {title: 'Event Type', name: 'eventtype', sortField: 'eventtype'},
    {title: 'Message', name: 'le_message', sortField: 'le_message'},
    {title: 'Student', name: 'student_name', sortField: 'student_name'},
    {title: 'Contract', name: 'le_contract', sortField: 'le_contract'},
    {title: 'User', name: 'usr_name', sortField: 'student_name'}
  ]
}
// {
//       "eventtype": "Invoice created",
//       "id": 1,
//       "le_message": "Created invoice None",
//       "le_time": "2017-07-23T10:26:05.665982Z",
//       "lt_id": 2,
//       "student_name": "Schellekens Marc",
//       "url": "http://vuedev:8081/api/v1.0/logging_types/1",
//       "usr_name": "API Test User"
//     },



// WEBPACK FOOTER //
// ./src/views/Event/FieldDefs.js